// @ts-nocheck
/* eslint-disable */
import { store } from "~/state/store";
import SceneLayerMulti from "./layer/multi";
import SceneProjection from "./projection";

export default class SceneProvider {
	_scene: Scene;

	_active: boolean;

	_visualiser: any;

	_projection: any;

	/**
	 * Hlavni trida provideru pro scenu.
	 */
	constructor(scene, visualiser) {
		this._scene = scene;
		this._active = false;
		this._visualiser = new visualiser(this);
		this._projection = new SceneProjection(scene);
	}

	/**
	 * Aktivace provideru.
	 *
	 * @param  {Scene} scene Instance sceny
	 * @param  {Object} state Aktualni stav sceny
	 * @return {JAK.Promise}
	 */
	activate(scene, state) {
		let promise = new JAK.Promise();

		this._active = true;
		this._scene = scene;

		let output = this._activate(state);

		if (output && typeof output.then === "function") {
			output.then(() => {
				this._restoreFromState(state);
				promise.fulfill();
			}, () => {});
		}
		else {
			this._restoreFromState(state);
			promise.fulfill();
		}

		return promise;
	}

	/**
	 * Deaktivace provideru.
	 *
	 * @return {JAK.Promise}
	 */
	deactivate() {
		let promise = new JAK.Promise();

		this._active = false;

		let output = this._deactivate();

		if (output && typeof output.then === "function") {
			output.then(() => {
				promise.fulfill();
			}, () => {});
		}
		else {
			promise.fulfill();
		}

		return promise;
	}

	/**
	 * Zmena feature - vola scena na aktivnim provideru.
	 *
	 * @param  {SceneFeature} sender Kdo to vola?
	 * @param  {SceneFeature} featureItem Ve ktere entite udalost nastala?
	 * @param  {Array} [args] Volitelne argumenty
	 * @return {Object} Zalezi dle typy volane funkce
	 */
	featureChange(sender, featureItem, args) {
		let scope = featureItem.vis ? this._visualiser : this;
		let method = featureItem.method;
		let allArgs = featureItem.sender ? [sender].concat(args) : args;

		return (scope && typeof scope[method] === "function" ? scope[method].apply(scope, allArgs) : null);
	}

	/* *************** 2d mercator projekce by default ****************** */

	/**
	 * Ziskani aktualniho viewportu ve WGS84
	 *
	 * @return {Object} klice lb (left bottom), rt (right top) + osy x a y
	 */
	getViewport() {
		return this._projection.getViewport();
	}

	/**
	 * Spocitani zoomu pro zobrazeni delky x a y na zemekouli. Chceme zapocist i padding?
	 *
	 * @param {Number} lenX Delka na rovnobezce
	 * @param {Number} lenY Delka na poledniku
	 * @param {Boolean} [usePadding = false]
	 * @param {Integer} [overlap] povoleni presahu v procentech
	 * @return {Number} Vysledny zoom
	 */
	countZoom(lenX, lenY, usePadding, overlap) {
		return this._projection?.countZoom(lenX, lenY, usePadding ? store.getState().map.padding : null, overlap) || 0;
	}

	/**
	 * Prevod pixelu na souradnice pomoci projekct providera.
	 *
	 * @param  {ScenePixel} pixel Vstupni pixel
	 * @param  {Number} [zoom] Vstupni zoom
	 * @return {SceneCoords}
	 */
	pixelToCoords(pixel, zoom) {
		return this._projection.pixelToCoords(pixel, zoom);
	}

	/**
	 * Prevod souradnic na pixel pomoci projekct providera.
	 *
	 * @param  {SceneCoords} pixel Vstupni souradnice
	 * @param  {Number} [zoom] Vstupni zoom
	 * @return {ScenePixel}
	 */
	coordsToPixel(coords, zoom) {
		return this._projection.coordsToPixel(coords, zoom)
	}

	/* *************** projekce ****************** */

	/**
	 * Bind signalu nad providerem - scene nyni staci pouze jeden bind pro 1 signal.
	 * Provider by mel fungovat nasledovne:
	 * - nabinduje si funkci (klidne i spolecnou) pro poslech signalu s danym jmenem
	 * - pri vyvolani signalu, vyvola zpetne signal nad scenou pres Scene.makeEvent(name, arg, sender)
	 * - name - vyvolany signal {String}
	 * - arg - data k signalu {Object}
	 * - [sender] - kdo signal vyvolal - tady jiz musi byt feature item, nikoliv provider item!
	 * @param  {String} name Nazev signalu
	 */
	addListener(name) {}

	/**
	 * Odstraneni poslouchani na nazev signalu - vola scena.
	 * @param  {String} name Nazev signalu
	 */
	removeListener(name) {}

	/**
	 * Nastaveni callback funkce pro kliknuti do mapy. Pouziti na starem userwebu, vyhnout se ve windy!
	 *
	 * @param {Function} cb Callback funkce
	 */
	setMapClick(cb) {}

	/**
	 * Nastav kurzor provideru.
	 *
	 * @param {String} cursor Styl pro kurzor
	 */
	setCursor(cursor) {}

	/**
	 * Ziskani DOMu pro obal vrstvy. Neda se bohuzel udelat jinak, pouziti pouze na starem userwebu!
	 *
	 * @return {Element}
	 */
	getLayerMarkerContainer() {
		return document.createElement("div");
	}

	/**
	 * Nastav stred projekce providera.
	 *
	 * @param {SceneCoords} center
	 */
	setCenter(center) {}

	/**
	 * Nastav stred a zoom projekce providera.
	 *
	 * @param {SceneCoords} center
	 * @param {Number} [zoom] Volitelny zoom
	 * @param {Boolean} [noAnim = false] Neanimovat?
	 * @return {JAK.Promise}
	 */
	setCenterZoom(center, zoom, noAnim) {
		return Promise.resolve({});
	}

	/**
	 * Nastaveni rozsahu pro zoom.
	 *
	 * @param {Number} min
	 * @param {Number} max
	 */
	setZoomRange(min, max) {}

	getScene() {
		return this._scene;
	}

	/**
	 * Uzamknuti providera.
	 */
	lock() {}

	/**
	 * Odemknuti providera.
	 */
	unlock() {}

	/**
	 * Znovu prepocet rozmery providera - roztahnuti do aktulniho kontentu.
	 */
	syncPort() {}

	/**
	 * Prekresleni providera.
	 */
	redraw() {}

	/**
	 * Vyplneni kontext menu!
	 */
	fillContextMenu() {}

	/**
	 * Ziskani controlu pro ovladani pomoci klavesnice!
	 */
	getKeyboardControl() {
		return null;
	}

	/**
	 * Pri aktivaci se vola tato metoda, ktera podle aktualniho stavu sceny provede update provideru.
	 *
	 * @param  {Object} state Aktualni stav sceny
	 */
	_restoreFromState(state) {
		let layerMulti = []

		this.setCursor(state.cursor);
		this.setMapClick(state.mapClick);

		if (typeof this._visualiser.createMarker === "function") {
			for (let id in state.markers) {
				let item = state.markers[id];

				this._visualiser.createMarker(item);
			}
		}

		if (typeof this._visualiser.createGeometry === "function") {
			for (let id in state.geometries) {
				let item = state.geometries[id];

				this._visualiser.createGeometry(item);
			}
		}

		state.layers.forEach(layer => {
			if (layer instanceof SceneLayerMulti) {
				layerMulti.push(layer);
			}
			else {
				if (layer.getCreateData().isMapset && typeof this._visualiser.createLayerFromMapset === "function") {
					this._visualiser.createLayerFromMapset(layer);
				}
				else if (typeof this._visualiser.createLayer === "function") {
					this._visualiser.createLayer(layer);
				}
			}
		});

		if (typeof this._visualiser.createLayer === "function") {
			layerMulti.forEach(layer => {
				this._visualiser.createLayer(layer);
			});
		}

		if (typeof this._visualiser.createControl === "function") {
			state.controls.forEach(control => {
				this._visualiser.createControl(control);
			});
		}

		if (typeof this._visualiser.createPano === "function") {
			state.pano.forEach(pano => {
				this._visualiser.createPano(pano);
			});
		}

		for (let signalName in state.listeners) {
			this.addListener(signalName);
		}
	}

	/**
	 * Abstraktni - aktivace provideru.
	 *
	 * @param  {Object} state Aktualni stav sceny
	 * @return {JAK.Promise}
	 * @abstract
	 */
	_activate(state) {}

	/**
	 * Abstraktni - deaktivace provideru.
	 *
	 * @return {JAK.Promise}
	 * @abstract
	 */
	_deactivate() {}
}
